export var Clear = "Clear";
export var IdentityPickerAlias = "Alias";
export var IdentityPickerContact = "Contact";
export var IdentityPickerContactInfo = "Contact information";
export var IdentityPickerDepartment = "Department";
export var IdentityPickerEmail = "Email";
export var IdentityPickerHeaderButtonLabel = "Go back";
export var IdentityPickerLoadingText = "Loading identities...";
export var IdentityPickerLocation = "Location";
export var IdentityPickerNoResultsText = "No identities found";
export var IdentityPickerOrganization = "Organization";
export var IdentityPickerPhoneNumber = "Phone number";
export var IdentityPickerPlaceholderFocusText = "Assign people";
export var IdentityPickerPlaceholderText = "No one selected";
export var IdentityPickerProfileCardAriaLabel = "Contact card";
export var IdentityPickerProfileCardButtonTooltip = "Show Contact Card";
export var IdentityPickerReportingTo = "Reporting to {0} ({1})";
export var IdentityPickerReportsTo = "Reports to";
export var IdentityPickerResultsFoundText = "Showing {0} results";
export var IdentityPickerStartChat = "Start chat";
export var IdentityPickerTitle = "Title";
export var Loading = "Loading...";
export var MultiIdentityPickerPlaceholderText = "Add people";
export var Remove = "Remove {0}";
export var UnknownUserOrGroup = "Unknown user or group: {0}";
